import React from "react";
import { useState } from "react";
import "./index.css";
import "../Profile/index.css";
import detailedImg from "../../assets/images/dashboard/detailedImg.png";
import img1 from "../../assets/images/dashboard/img1.png";
import img2 from "../../assets/images/dashboard/img2.png";
import img3 from "../../assets/images/dashboard/img3.png";
import img4 from "../../assets/images/dashboard/img4.png";
import img5 from "../../assets/images/dashboard/img5.png";
import img6 from "../../assets/images/dashboard/img6.png";
import { ImPower } from "react-icons/im";
import { YouMayAlsoLike } from "../Profile/YouMayAlsoLike";
import { FAQSection } from "../ContactUs/FAQSection";
import { StartYourProject } from "../Home/StartYourProject";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { IoBed } from "react-icons/io5";
import { FaBath } from "react-icons/fa6";
import { BiSolidArea } from "react-icons/bi";

export const BiddingPropertyDetails = () => {
  const [mainImage, setMainImage] = useState(detailedImg);
  // modal state
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div className="biddingContainer">
      <div className="breadcrumbContainer">
        <Breadcrumb className="container">
          <Breadcrumb.Item href="/properties">Properties</Breadcrumb.Item>
          <Breadcrumb.Item href="/profile">Property Name</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className="container">
        <div className="appDetailsHeader">
          <div className="appDetailsLeft">
            <div>Property Name</div>
            <div>Gachibowli, Hyderabad</div>
          </div>
          <div className="appDetailsRight">
            <div>Price</div>
            <div>
              <span>₹55,00,000</span>
              <strike>₹65,00,000</strike>
            </div>
          </div>
        </div>
        <div className="appDetailsGrid">
          <div className="appDetailsLeftSide">
            <div className="appDetailsImg">
              <img src={mainImage} alt="Main" />
            </div>
            <div className="appDetailsSubImg">
              {[img1, img2, img3, img4, img5, img6].map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Sub ${index}`}
                  onMouseEnter={() => setMainImage(img)}
                  onMouseLeave={() => setMainImage(detailedImg)}
                  style={{ cursor: "pointer" }}
                />
              ))}
            </div>
          </div>
          <div className="appDetailsRightSide">
            <div className="appDescriptionContainer">
              <div>Description</div>
              <div>
                This spacious 3BHK flat in Maple Heights offers abundant light
                and ventilation with a serene park-facing balcony. Located just
                10 mins from Panjagutta, it’s ideal for professionals and
                families seeking peaceful yet well-connected living.
              </div>
              <div className="appDescGrid">
                <div className="appDescContent">
                  <span className="d-flex">
                    <span>
                      <IoBed />
                    </span>
                    Bedrooms
                  </span>
                  <span>04</span>
                </div>
                <div className="appDescContent">
                  <span className="d-flex">
                    <span>
                      <FaBath />
                    </span>
                    Bathrooms
                  </span>
                  <span>03</span>
                </div>
                <div className="appDescContent">
                  <span className="d-flex">
                    <span>
                      <BiSolidArea />
                    </span>
                    Area
                  </span>
                  <span>2,500 Square Feet</span>
                </div>
              </div>
            </div>
            <div className="appFeatureContainer">
              <div>Key Features</div>
              <div>
                {[
                  "Enjoy peaceful mornings with a view of the community park.",
                  "Just 10 minutes from Panjagutta and walking distance to metro station.",
                  " Includes security, parking, lift, children’s play area, and clubhouse.",
                  "100% legal clarity with all documents checked and verified.",
                  "Private garage and ample storage space.",
                ].map((list) => (
                  <ul className="keyfeaturesList">
                    <li
                      style={{
                        borderLeft: "1px solid #2E5B3D",
                        paddingLeft: "10px",
                      }}
                    >
                      <ImPower />
                      <span className="ms-2">{list}</span>
                    </li>
                  </ul>
                ))}
              </div>
            </div>
            <div className="btnApplyBid">
              <button onClick={handleShow}>Apply for Bid</button>
            </div>
          </div>
        </div>
      </div>
      {/* modal  */}
      <div>
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <div className="modalTitleConfirm">Confirm Your Interest</div>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div className="modalSubtitle">
                Before proceeding to payment, please note:
              </div>
              <ul className="modalList">
                <li>This is a non-refundable application fee.</li>
                <li>You'll be eligible to visit the property after payment.</li>
                <li>
                  Only paid users will be allowed to participate in the initial
                  bidding round.
                </li>
              </ul>
              <div className="modalBtnContainer">
                <div className="modalBtnProceed">
                  <button>Proceed to Pay</button>
                </div>
                <div className="modalBtnCancel">
                  <button onClick={handleClose}>Cancel</button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
      {/* you may also like  */}
      <YouMayAlsoLike />

      {/* faq section  */}
      <FAQSection />
      {/* start your property  */}
      <StartYourProject />
    </div>
  );
};
